/**
 * @file ajax请求
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-07-06 Baidu
 */
import _ from 'lodash';
import {envConfig} from '../common/envConfig';

function request(url, data, options) {
    let defaults = {
        url: url,
        data: _.isEmpty(data) ? '' : JSON.stringify(data),
        method: 'GET',
        contentType: 'application/json; charset=utf-8'
    };
    options = options ? _.extend(defaults, options) : defaults;
    return $.ajax({
        url: options.url,
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        headers: options.headers ? options.headers : {},
        method: options.method,
        contentType: options.contentType,
        data: options.data,
        success: data => data
    });
}
export const geneRequester = url => {
    if (_.isString(url)) {
        // 只有一个URL，直接返回封装过的请求方法
        return function (data, options, query) {
            if (query !== null && query !== '') {
                return request(url + '?' + query, data, options);
            }
            return request(url, data, options);
        };
    }
    else if (_.isObject(url)) {
        // 是一个集合，那么每个项目都封装一下
        let map = _.clone(url);
        _.each(map, function (url, name) {
            if (_.isString(url)) {
                map[name] = function (data, options, query) {
                    if (query !== null && query !== '') {
                        return request(url + '?' + query, data, options);
                    }
                    return request(url, data, options);
                };
            }
            // 如果不是string那可能封装过了
        });
        return map;
    }
};

export const getBduss = () => {
    return $.ajax({
        url: `${envConfig().dwzBaiduDomain}/bduss/get`,
        xhrFields: {
            withCredentials: true
        },
        method: 'GET'
    });
};
